import { SagaIterator } from "@redux-saga/core";
import { startSubmit, stopSubmit } from "redux-form";
import { call, put, takeLatest } from "redux-saga/effects";

import { drugSearchActions } from "@/App/actions";
import { PageAlert } from "@/App/components";
import { ActionTypes } from "@/App/constants/actionTypes";
import apiService from "@/App/service";
import { DrugTypes } from "@/types";

function* searchForDrug(data: DrugTypes.DrugSearchOptions): Generator {
  return yield apiService({
    url: "/mddb/drug/list",
    method: "POST",
    data,
  });
}

export function* searchForDrugWorker(action: ReturnType<typeof drugSearchActions.searchForDrug>): SagaIterator {
  const { searchForDrugResults } = drugSearchActions;
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));
    const { results, result_count } = yield call(searchForDrug, payload);
    yield put(searchForDrugResults({ results, result_count }));
    yield put(stopSubmit(formName));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(stopSubmit(formName));
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* drugSearchWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SEARCH_FOR_DRUG, searchForDrugWorker);
}
